import { initializeApp } from "firebase/app";
import { getAuth, sendEmailVerification } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, db, auth, storage, sendEmailVerification };


// gsutil cors set cors.json gs://fire-inspector-1.appspot.com
// gsutil cors get gs://fire-inspector-1.appspot.com


//gsutil cp gs://dart-pdf-api-bucket/firechecked_gcp.zip .
//unzip firechecked_gcp.zip
//cd firechecked_gcp

//gcloud builds submit --config cloudbuild.yaml .

//gcloud run deploy firechecked-gcp \
//  --image gcr.io/fire-inspector-1/pdf-api \
//  --platform managed \
// --allow-unauthenticated \
//  --region europe-west1

//firebase deploy --only functions 